<template>
  <div class="shared shared__warehouse shared__warehouse--add-product container">
    <history-back :path-name="`${role}Warehouses`" :params="{estateId}"></history-back>
    <h2 class="title is-2">Carica prodotti in magazzino</h2>
    <div class="field is-grouped">
      <b-field label="Numero DDT *">
        <b-input v-model.trim="ddtCode" type="text" size="32"></b-input>
      </b-field>
      <b-field label="Data DDT *">
        <b-datepicker
          :first-day-of-week="1"
          :max-date="today"
          :month-names="monthNames"
          :day-names="dayNames"
          v-model="ddtDate"
          placeholder="Clicca per selezionare"
          icon="calendar"></b-datepicker>
      </b-field>
      <b-field label="Tipo *">
        <b-select v-model="ddtType" @input="onTypeChange">
          <option :value="purchaseRequestType">Acquisto diretto</option>
          <option :value="orderType">Consegna</option>
        </b-select>
      </b-field>
    </div>

    <add-purchase-request-component v-if="whatToAdd === purchaseRequestType"
                                    :role="this.role"
                                    :warehouse-id="warehouseId"
                                    :inventory="inventory"
                                    :ddt-code="ddtCode"
                                    :ddt-date="ddtDate"
                                    :ddt-type="ddtType"></add-purchase-request-component>

    <add-order-request-component v-if="whatToAdd === orderType"
                                 :role="this.role"
                                 :warehouse-id="warehouseId"
                                 :ddt-code="ddtCode"
                                 :ddt-date="ddtDate"
                                 :ddt-type="ddtType"></add-order-request-component>
  </div>
</template>

<script>
  import {api, utils} from '../../../helpers'
  import {mapState} from 'vuex'
  import locale from '../../../locale/it'
  import HistoryBack from '../../actions/HistoryBack'
  import AddPurchaseRequestComponent from './AddPurchaseRequestComponent'
  import AddOrderRequestComponent from './AddOrderRequestComponent'

  export default {
    name: 'AddProducts',
    components: {AddOrderRequestComponent, AddPurchaseRequestComponent, HistoryBack},
    data () {
      return {
        estateId: this.$route.params.estateId || null,
        warehouseId: Number.parseInt(this.$route.params.id, 10) || null,
        today: new Date(),
        monthNames: locale.monthNames,
        dayNames: locale.dayNames,
        inventory: [],
        ddtCode: null,
        ddtDate: null,
        ddtType: null,
        whatToAdd: ''
      }
    },
    computed: {
      ...mapState('auth', {
        role: 'role'
      }),
      purchaseRequestType () {
        return 'PURCHASE_REQUEST'
      },
      orderType () {
        return 'ORDER'
      }
    },
    mounted () {
      if (typeof this.$route.params.estateId === 'undefined' ||
        typeof this.$route.params.id === 'undefined') { // this is the warehouse id
        this.$router.replace({name: `${this.role}Warehouses`})
      }
    },
    methods: {
      onTypeChange (ddtType) {
        let modal = this.$loading.open()
        let result = null
        switch (ddtType) {
          case this.orderType:
            this.whatToAdd = this.ddtType
            result = ddtType
            modal.close()
            break
          case this.purchaseRequestType:
            api.getPurchaseRequestsProductsByEstate(this.estateId).then(response => {
              if (typeof response === 'undefined') {
                utils.errors(['Non ci sono richieste d\' acquisto da caricare.'])
                this.inventory = []
              } else {
                this.inventory = response
              }
              modal.close()
            }).catch(errors => utils.errors(errors, modal))
            this.whatToAdd = this.ddtType
            result = ddtType
            break
          default:
            utils.errors(['Tipo documento selezionato non valido'])
            modal.close()
        }

        return result
      }
    }
  }
</script>

<style scoped lang="scss">
  .field.is-grouped, .table-component {
    margin-bottom: 2em;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/warehouses/AddProducts.vue